define(
    "diy/undo-redo/UiManager",
    [
        'diy/undo-redo/constants',
        'diy/undo-redo/UiEntry'
    ],
    /**
     *
     * @param {module.undoRedo.constants} constants
     * @param {module.undoRedo.UiEntry} UiEntry
     * @returns {*}
     */
    function (constants, UiEntry) {
        'use strict';

        var UiManager;
        /**
         * @class module.undoRedo.UiManager
         * @template module.undoRedo.UiManager
         * @lends {module.undoRedo.UiManager.prototype}
         * @constructor
         */
        UiManager = Klazz.extend({
            /** @type {module.undoRedo.Ui} */
            ui: null,
            /** @type {module.undoRedo.Api} */
            api: null,
            /**
             *
             * @param {module.undoRedo.Ui} ui
             * @param {module.undoRedo.Api} api
             */
            initialize: function intitialize(ui, api) {
                this.ui = ui;
                this.api = api;
            },
            /**
             *
             * @param {{undo:[], redo:[], last:{}}} incoming
             */
            handle: function handle(incoming) {
                var parsed = {
                    undoList: [],
                    redoList: [],
                    lastEntry: null
                };

                this.filter(incoming.undo).forEach(
                    function (entry) {
                        parsed.undoList.push(new UiEntry(entry, this.api, constants.types.UNDO));
                    }.bind(this)
                );
                this.filter(incoming.redo).forEach(
                    function (entry) {
                        parsed.redoList.push(new UiEntry(entry, this.api, constants.types.REDO));
                    }.bind(this)
                );

                if (typeof incoming.last !== 'undefined' && incoming.last !== null) {
                    this.filter([incoming.last]).forEach(
                        function (entry) {
                            parsed.lastEntry = new UiEntry(entry, this.api, entry.getType());
                        }.bind(this)
                    );
                }

                this.ui.refresh(parsed);
            },

            /**
             *
             * @param {module.undoRedo.Entry[]} chain
             * @returns {module.undoRedo.Entry[]}
             */
            filter: function filter(chain) {
                return chain.filter(function (entry /*, index, array */) {
                    return !(
                    entry.getExecutionType() === constants.executionType.SERVER &&
                    entry.getIsSessionHead() === true
                    );
                });
            }

        });
        return UiManager;
    }
);



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/undo-redo/UiManager.js
 ** module id = 911
 ** module chunks = 0
 **/